import React from 'react';

interface AdPreviewProps {
  title?: string;
  body?: string;
  imageUrl?: string;
  videoUrl?: string;
  ctaText?: string;
  format?: string;
}

/** Xem trước quảng cáo Native đúng như nó hiện trong feed cab.vn (giống NativeAdCard, không tương tác). */
const AdPreview: React.FC<AdPreviewProps> = ({ title, body, imageUrl, videoUrl, ctaText, format }) => (
  <div className="box border border-[#DEE0E6] dark:border-slate-700 bg-white dark:bg-dark2 rounded-xl p-4">
    <div className="flex items-center justify-between mb-2">
      <span className="text-[11px] uppercase tracking-wide text-[#657384] dark:text-slate-400">
        Được tài trợ
      </span>
      <span className="text-[10px] px-2 py-0.5 rounded-full bg-slate-100 dark:bg-slate-700 text-[#657384] dark:text-slate-300">
        Quảng cáo
      </span>
    </div>
    {title ? <h3 className="font-semibold text-[15px] ui-text mb-1">{title}</h3> : (
      <h3 className="font-semibold text-[15px] ui-muted mb-1 italic">Tiêu đề quảng cáo…</h3>
    )}
    {body ? <p className="text-sm ui-muted mb-2">{body}</p> : null}
    {videoUrl ? (
      <video
        src={videoUrl}
        poster={imageUrl || undefined}
        controls
        playsInline
        preload="metadata"
        className="w-full rounded-lg max-h-64 bg-black"
      />
    ) : imageUrl ? (
      <img src={imageUrl} alt={title || 'ad'} className="w-full rounded-lg object-cover max-h-64" />
    ) : (
      <div className="w-full h-40 rounded-lg bg-slate-100 dark:bg-slate-700 grid place-items-center text-xs ui-muted">
        {format === 'Video' ? 'Video quảng cáo' : 'Ảnh/banner sẽ hiện ở đây'}
      </div>
    )}
    <div className="mt-3">
      <span className="inline-flex items-center rounded-lg bg-[#0071A6] text-white text-sm font-medium px-4 py-2">
        {ctaText || 'Tìm hiểu thêm'}
      </span>
    </div>
  </div>
);

export default AdPreview;
